import { SlotBetResult } from "../types/SlotBetResult";

export const parseSlotMachineFinishedBetEvent = (data: any) => {
  return {
    slotMachineId: Number(data.slotMachineId),
    betId: Number(data.betId),
    player: data.player,
    nonce: JSON.parse(data.nonce),
    spinCount: data.spinCount,
    amountPerSpin: data.amountPerSpin,
    totalReward: data.totalReward,
    rewardReceived: data.rewardReceived,
    feeAmount: data.feeAmount,
    timestamp: data.timestamp,
    block: data.block,
  } as SlotBetResult;
};
